export function isNullOrEmpty(val) {
     // Evaluates to true if NOT undefined, null, NaN, empty string, 0 or false
    if (val) {
        return false;
    }
    else {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/LanguageHelpers.js